import { render, staticRenderFns } from "./Create-New-Equipment.vue?vue&type=template&id=25cf18ad"
import script from "./Create-New-Equipment.vue?vue&type=script&lang=js"
export * from "./Create-New-Equipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports